import { DateWithSession, Session } from '@eventbrite/checkout-fairy-api';
import { getAPIDateTimeFormats } from '@eventbrite/datetime-fns';
import { gettext } from '@eventbrite/i18n';
import { EventStatus } from '../../../constants/eventStatus';

export const getListItemsFromSessions = ({
    sessions,
    timezone,
    locale,
    selectedSession,
}: {
    sessions: DateWithSession['sessions'];
    timezone: string;
    locale: string;
    selectedSession: Session | undefined;
}) =>
    sessions
        ?.sort((a, b) => {
            if (a.availability === b.availability) {
                return (
                    a.startDatetime?.localeCompare(b.startDatetime ?? '') ?? 0
                );
            }
            if (a.availability === EventStatus.soldOut) {
                return 1;
            }
            if (b.availability === EventStatus.soldOut) {
                return -1;
            }
            return 0;
        })
        ?.map((session) => {
            const content = session.startDatetime
                ? getAPIDateTimeFormats({
                      utc: session.startDatetime,
                      timezone,
                      locale,
                  }).shortTime
                : '';

            return {
                content,
                ariaLabel: content
                    ? gettext('Pick the %(sessionTime)s session', {
                          sessionTime: content,
                      }).toString()
                    : '',
                selected: session.id === selectedSession?.id,
                payload: session,
                disabled: session.availability === EventStatus.soldOut,
            };
        });
